import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import "./Menu.css"
import { useAuth } from '../../pages/login/connect/Login';
import LoginAlert from '../LoginAlert/LoginAlert';

function Menu() {
    const [showLoginAlert, setShowLoginAlert] = useState(false)
    const [activeMenuId, setActiveMenuId] = useState(2)
    const navigate = useNavigate();
    const menuItems = [
        { id: 5, src: "/icons/home.svg", alt: "خانه", link: "/AllADS", active: "/icons/home-active.svg" },
        { id: 4, src: "/icons/groups.svg", alt: "دسته بندی ها", link: "/CategoryView", active: "/icons/groups-active.svg" },
        { id: 3, src: "/icons/red-register-group.svg", alt: "ثبت آگهی", link: "/RegisterAD", active: "/icons/center.svg" },
        { id: 2, src: "/icons/all-ads.svg", alt: "همه آگهی ها", link: "/", active: "/icons/all-ads-active.svg" },
        { id: 1, src: "/icons/profile.svg", alt: "پروفایل", link: "/Profile", active: "/icons/profile-active.svg" },
    ]
    const checkAuthForAddOrder = (id) => {
        if (localStorage.getItem("veeuAuthData")) {
            if (id == 3) {
                navigate("/RegisterAD")
            } else if (id == 1) {
                navigate("/Profile")
                setActiveMenuId(1)
            }
        } else {
            setShowLoginAlert(true)
        }
    }

    return (
        <>
            <div className='h-full w-full hidden sm:block md:block lg:block'>
                <div className='w-full z-30 py-2 fixed bottom-0 flex items-center justify-around border-t shadow-sm rounded-t-3xl bg-[#f0f8ffa1] backdrop-blur-sm'>
                    {
                        menuItems.map(item => (
                            item.id == 3 || item.id == 1 ? (
                                <div onClick={() => checkAuthForAddOrder(item.id)} key={item.id} className='flex flex-col items-center justify-center gap-2'>
                                    <img src={activeMenuId === item.id ? item.active : item.src} alt={item.alt} />
                                </div>
                            ) : (
                                <Link onClick={() => setActiveMenuId(item.id)} key={item.id} to={item.link} className='flex flex-col items-center justify-center gap-2'>
                                    <img src={activeMenuId === item.id ? item.active : item.src} alt={item.alt} />
                                </Link>
                            )
                        ))
                    }
                </div>
            </div>
            {
                showLoginAlert ? (
                    <LoginAlert showLoginAlert={showLoginAlert} setShowLoginAlert={setShowLoginAlert} />
                ) : ""
            }
        </>
    )
}

export default Menu